<template>
  <div id="contenedor-registrar-nuevo-programa">
    <v-form v-model="formularioValido" ref="editarContratoProgramaObra">
      <v-card flat>
        <v-card-title class="secondary--text">
          Editar programa de obra
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2 mb-2"></v-divider>
        <v-card-subtitle class="grey lighten-4 mx-2 rounded-lg">
          <span class="font-weight-bold">
            Fecha inicio
          </span>
          {{ formatoFecha(fechaInicio) }}
          -
          <span class="font-weight-bold">
            Fecha término
          </span>
          {{ formatoFecha(fechaTermino) }}
        </v-card-subtitle>
        <v-divider class="mx-2 mt-2"></v-divider>
        <v-card-text>
          <agregar-programa
            v-if="!validarMonto"
            v-on:seAgrego="seAgregoPrograma"
            :fecha-inicio="getFechaInicio"
            :fecha-termino="fechaTermino"
            :key="getFechaInicio"
          ></agregar-programa>
          <v-list>
            <v-list-item-group>
              <div
                v-for="(programa, index) in programaDeObra.programa"
                :key="`programa-${index}`">
                <v-list-item @click="editarEstePrograma(programa)">
                  <v-list-item-action>
                    <v-chip>
                      {{ (index + 1) }}
                    </v-chip>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>{{ formatoFecha(programa.fechaInicio) }}</span>
                      -
                      <span>{{ formatoFecha(programa.fechaTermino) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Plazo {{ programa.plazo }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-row
                      justify="space-between"
                      no-gutters>
                      <v-col>
                        <v-chip color="#E6E6F9">
                          {{ programa.monto | currency }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </div>
              <v-list-item>
                <v-list-item-content>
                  <span class="text-right">Restante:</span>
                  <span
                    class="text-right font-weight-bold">
                    {{ (getTotalContratado - sumarMontos) | currency}}
                  </span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip :color="validarMonto ? 'success' : 'warning'">
                    <v-icon v-if="validarMonto" left>mdi-check</v-icon>
                    {{ sumarMontos | currency }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-divider></v-divider>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarPrograma"
            :disabled="(getTotalContratado - sumarMontos) !== 0"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrar">Cancelar</v-btn>
          <v-btn
            color="success"
            @click="mixActualizarPrograma"
            :disabled="(getTotalContratado - sumarMontos) !== 0">
            <v-icon left>mdi-content-save</v-icon>Guardar
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-form>
    <v-dialog v-model="mostrarEditarPrograma" width="350">
      <editar-programa
        v-on:seEdito="mostrarEditarPrograma = !mostrarEditarPrograma"
        :estePrograma="estePrograma">
      </editar-programa>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixProgramaContrato from './mixProgramaContrato';
import AgregarPrograma from './AgregarPrograma.vue';
import EditarPrograma from './EditarPrograma.vue';

export default {
  name: 'EditarProgramaDeObra',
  mixins: [mixProgramaContrato],
  props: {
    contrato: {
      type: Object,
      required: true,
    },
    programaExistente: {
      type: Object,
      required: true,
    },
  },
  components: {
    AgregarPrograma,
    EditarPrograma,
    CustomButton,
  },
  data() {
    return {
      mostrarEditarPrograma: false,
      formularioValido: false,
      enviadoFormulario: false,
      programaDeObra: {
        idContrato: this.$route.params.idContrato,
        programa: [],
      },
      estePrograma: null,
    };
  },
  mounted() {
    this.programaDeObra = JSON.parse(JSON.stringify(this.programaExistente));
    // .slice()
    // .sort(
    //   (a, b) => new Date(`${a.fechaTermino} 00:00:0`)
    //     - new Date(`${b.fechaTermino} 00:00:0`),
    // );
    this.programaDeObra.programa
      .sort(
        (a, b) => new Date(`${a.fechaTermino} 00:00:0`)
          - new Date(`${b.fechaTermino} 00:00:0`),
      );
  },
  methods: {
    formatoFecha(fecha) {
      return new Date(`${fecha} 00:00:0`).toLocaleDateString();
    },
    editarEstePrograma(programa) {
      this.estePrograma = programa;
      this.mostrarEditarPrograma = true;
    },
    limpiarFormulario() {
      this.$refs.editarContratoProgramaObra.reset();
      this.programaDeObra.programa = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">
</style>
